<template>
  <basic-card class="global-basic-card" padding hideHeader>
    <avue-crud
        class="global-table"
        :option="option"
        v-model:search="search"
        v-model:page="page"
        v-model="form"
        :table-loading="loading"
        :data="data"
        :permission="permissionObj"
        ref="crud"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="refreshChange"
        @on-load="onLoad"
      >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
        </div>
      </template>
    </avue-crud>
  </basic-card>
</template>

<script>
import { mapGetters } from 'vuex';
import func from '@/utils/func';
import 'nprogress/nprogress.css';
import { getLogPage } from '@/api/system/user';
import { filterDollarKeys } from '@/utils/util';

export default {
  data() {
    return {
      form: {},
      query: {},
      search: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // height: 'auto',
        maxHeight: 640, // 因为设计要求分页不要固定在底部 height: 'auto'
        calcHeight: 84,
        menu: false,
        tip: false,
        searchShow: true,
        searchGutter: 20,
        searchSpan: 4,
        searchMenuSpan: 12,
        searchLabelWidth: 'auto',
        searchMenuPosition: 'right',
        // searchGutter: 10,
        border: false,
        index: true,
        viewBtn: true,
        addBtn: false,
        emptyBtn: false,
        searchBtn: false,
        selection: false,
        dialogClickModal: false,
        editBtnText: this.Lang.btn.ignore,
        editBtn: false,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        indexLabel: this.Lang.table.serialNumber,
        selection: false,
        indexWidth: '100%',
        dialogType: 'drawer',
        dialogClickModal: false,
        searchLabelWidth: 'auto',
        searchLabelPosition: 'top',
        labelWidth: 'auto',
        labelPosition: 'top',
        searchLabelSuffix: ' ',
        column: [
          {
            label: this.Lang.label.content,
            prop: 'title',
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.table.time,
            prop: 'createTime',
            type: 'date',
            search: true,
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.label.operator,
            prop: 'createBy',
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj[btnType+'Btn'] = true; // 兼容
          if (btnType === 'delete') {
            obj.delBtn = true;
          }
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // func.calculateHeaderHeight(this);
  },
  methods: {
    // 自定义搜索
    handleSearch() {
      console.log(this.search);
      const params = filterDollarKeys(this.search);
      this.onLoad(this.page, params);
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      const query = Object.assign(this.query, params);
      getLogPage(page.currentPage, page.pageSize, query).then(res => {
        const data = res.data.data || {};
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
